import classNames from 'classnames';
import { ReactElement, ReactNode } from 'react';
import './Overtitle.scss';

type OvertitleProps = {
  children?: ReactNode;
  label?: ReactNode;
  element?: ReactElement<{
    children: ReactNode;
    className: string;
  }>;
};

function Overtitle({ label, children, element = <span /> }: OvertitleProps): JSX.Element {
  return (
    <element.type {...element.props} className={classNames('Overtitle', element.props.className)}>
      {label}
      {children}
    </element.type>
  );
}

export default Overtitle;
